/* @ngInject */
const resource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.phone}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'search': {
      method: 'POST',
    },
  })
}

export default resource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/services/resource.service.js